import { ContactDetail } from './ContactDetail';

// The contact page the grids open, on the contact in ?contactId=, or a new one without it.
export function ContactMainSample() {
  return <ContactDetail queryParameterName="contactId" />;
}
